(function () {
  function initPredictiveSearch(modal, index) {
    var form = modal.querySelector('.search-bar');
    var input = modal.querySelector('[data-predictive-search-input]');
    var resultsWrapper = modal.querySelector('[data-predictive-search-results]');
    var resultsContent = modal.querySelector('[data-predictive-search-content]');
    var popularSearches = modal.querySelector('[data-predictive-search-popular]');
    var closeButton = modal.querySelector('.close-search');
    var searchContainer = modal.closest('.site-header__search');
    var openButton = searchContainer ? searchContainer.querySelector('.serach_icon') : null;
    var endpoint = modal.getAttribute('data-predictive-search-url');
    var loadingText = modal.getAttribute('data-predictive-search-loading') || 'Loading';
    var debounceTimer = null;
    var requestController = null;
    var lastTerm = '';

    if (!form || !input || !resultsWrapper || !resultsContent || !endpoint) return;

    var resultsId = 'predictive-search-results-' + index;
    resultsContent.id = resultsId;
    input.setAttribute('aria-controls', resultsId);

    function setOpen(isOpen) {
      resultsWrapper.hidden = !isOpen;
      input.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (popularSearches) popularSearches.hidden = isOpen;
    }

    function resetResults() {
      if (requestController) requestController.abort();
      requestController = null;
      lastTerm = '';
      resultsContent.innerHTML = '';
      setOpen(false);
      input.classList.remove('s-loading');
    }

    function showLoading() {
      resultsContent.innerHTML = '<div class="predictive-search__loading" role="status">' + loadingText + '</div>';
      input.classList.add('s-loading');
      setOpen(true);
    }

    function renderResults(markup, term) {
      if (term !== input.value.trim()) return;

      var documentFragment = new DOMParser().parseFromString(markup, 'text/html');
      var section = documentFragment.querySelector('#shopify-section-predictive-search');
      var content = section ? section.innerHTML : '';

      if (!content) throw new Error('Predictive search section was not returned');

      resultsContent.innerHTML = content;
      input.classList.remove('s-loading');
      setOpen(true);
    }

    function fetchResults(term) {
      if (requestController) requestController.abort();
      requestController = new AbortController();
      lastTerm = term;
      showLoading();

      var url = endpoint
        + '?section_id=predictive-search'
        + '&q=' + encodeURIComponent(term)
        + '&resources[type]=product'
        + '&resources[limit]=4'
        + '&resources[options][unavailable_products]=last';

      fetch(url, {
        signal: requestController.signal,
        headers: { Accept: 'text/html' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error(response.statusText);
          return response.text();
        })
        .then(function (markup) {
          renderResults(markup, term);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          input.classList.remove('s-loading');
          resetResults();
        });
    }

    function searchCurrentValue(immediately) {
      var term = input.value.trim();
      window.clearTimeout(debounceTimer);

      if (term.length < 2) {
        resetResults();
        return;
      }

      if (term === lastTerm && resultsContent.innerHTML) {
        setOpen(true);
        return;
      }

      if (immediately) {
        fetchResults(term);
        return;
      }

      debounceTimer = window.setTimeout(function () {
        fetchResults(term);
      }, 250);
    }

    input.addEventListener('input', function () {
      searchCurrentValue(false);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') resetResults();
    });

    if (closeButton) closeButton.addEventListener('click', resetResults);

    if (openButton) {
      openButton.addEventListener('click', function () {
        window.setTimeout(function () {
          if (document.body.classList.contains('search_full_active')) {
            searchCurrentValue(true);
          }
        }, 0);
      });
    }

    form.addEventListener('submit', function (event) {
      if (!input.value.trim()) event.preventDefault();
    });
  }

  function init() {
    document.querySelectorAll('[data-predictive-search]').forEach(initPredictiveSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
